module.exports = __webpack_public_path__ + "img/restaurant-9.cb0ea4b1.jpg";